var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0165 16.0075C19.3519 16.0075 19.6237 16.2483 19.6237 16.5454C19.6237 16.8178 19.3953 17.0428 19.0989 17.0784L19.0165 17.0834H12.6815C12.3462 17.0834 12.0743 16.8425 12.0743 16.5454C12.0743 16.2731 12.3027 16.048 12.5991 16.0124L12.6815 16.0075H19.0165ZM12.8551 3.68054C14.0047 2.66207 15.8693 2.66207 17.0189 3.68054L18.2124 4.73785C19.362 5.75631 19.362 7.40823 18.2124 8.42669L9.24187 16.3738C8.72893 16.8283 8.03347 17.0833 7.30758 17.0833H3.63383C3.29255 17.0833 3.0183 16.8342 3.0268 16.5319L3.11922 13.2479C3.13759 12.6272 3.42427 12.0355 3.91978 11.5965L12.8551 3.68054ZM12.1606 5.81585L4.77851 12.3572C4.50307 12.6012 4.34344 12.9307 4.33324 13.2754L4.25614 16.007L7.30758 16.0074C7.66663 16.0074 8.01193 15.8954 8.28447 15.6931L8.38315 15.6131L15.8018 9.04085L12.1606 5.81585ZM16.1602 4.4413C15.4849 3.84299 14.3892 3.84299 13.7138 4.4413L13.0199 5.05502L16.6602 8.28002L17.3537 7.66593C17.9915 7.10086 18.027 6.20363 17.46 5.60165L17.3537 5.49861L16.1602 4.4413Z",
    fill: "#EDA240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit_pen.fd2b5d8f.svg";
export { ForwardRef as ReactComponent };